import { Routes } from '@angular/router';
import { AuthGuardService } from '../guards/auth-guard.service';
import { TransactionEditComponent } from './transaction-edit/transaction-edit.component';
import { TransactionComponent } from './transaction.component';

export const transactionsRoutes: Routes = [
  {
    path: 'transaction',
    canActivate: [ AuthGuardService ],
    children: [
      {
        path: ':transactionId/edit',
        component: TransactionEditComponent,
      },
      {
        path: '',
        component: TransactionComponent
      }
    ]
  },
];



// WEBPACK FOOTER //
// ./src/app/transaction/transaction.routes.ts